import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { salesChannelTitleKey } from '../onboarding-options';
import type { OnboardingSnapshot } from '../onboarding-snapshot';
import type { OnboardingStep } from '../onboarding-steps';
import { StatusBadge } from '../StatusBadge';
import { StoreLogo } from '../StoreLogo';
import { PanelCard } from './PanelCard';
import type { PanelCardState } from './panel-state';

/** Where the brand sells, and whether its store is connected. */
export const SalesPanelCard = ({
  snapshot,
  step,
  state,
}: {
  snapshot: OnboardingSnapshot;
  step: OnboardingStep;
  state: PanelCardState;
}) => {
  const { t } = useTranslation();
  const channel = state === 'upcoming' ? null : snapshot.salesChannel;
  const showsSalesStatus =
    (step === 'connect' || step === 'welcome') && !!channel && channel !== 'none';
  const declarationOnly = channel === 'stripe' || channel === 'api';

  return (
    <PanelCard state={state}>
      <Flex align="center" gap="12px">
        <Flex
          flex="none"
          w="34px"
          h="34px"
          borderRadius="9px"
          bg="softCream"
          align="center"
          justify="center"
        >
          <StoreLogo channel={channel} size={18} />
        </Flex>
        <Box flex="1" minW={0}>
          <Text fontFamily="heading" fontSize="13px" fontWeight="600" color="ink">
            {t('onboarding.brandPanel.sales.label')}
          </Text>
          <Text fontSize="12.5px" color="inkMuted" truncate>
            {channel ? t(salesChannelTitleKey(channel)) : t('onboarding.brandPanel.sales.hint')}
          </Text>
        </Box>
        {showsSalesStatus && (
          <StatusBadge
            tone={declarationOnly ? 'neutral' : snapshot.isStoreConnected ? 'ok' : 'todo'}
          >
            {t(
              declarationOnly
                ? 'onboarding.badge.declared'
                : snapshot.isStoreConnected
                  ? 'onboarding.badge.connected'
                  : 'onboarding.badge.toConnect'
            )}
          </StatusBadge>
        )}
      </Flex>
    </PanelCard>
  );
};
